import { memo } from 'react';
import { Stack, Typography } from '@mui/material';
import {
    CheckCircle as CheckCircleIcon,
    HelpOutlined as HelpOutlineIcon,
} from '@mui/icons-material';
import ChurchToolsLogo from '@/assets/ChurchTools.svg';

interface CategoryItemCTItemProps {
    name: string;
    responsible: string;
    agreed: boolean;
}

const CategoryItemChurchTools = ({ name, responsible, agreed }: CategoryItemCTItemProps) => {
    return (
        <Stack
            direction="row"
            sx={{
                alignItems: 'center',
                gap: 3,
                pl: 1,
                pr: 1.5,
                py: 0.5,
                border: 1,
                borderLeft: 3,
                borderColor: agreed ? 'success.main' : 'warning.main',
                borderRadius: 1,
                background: agreed
                    ? 'linear-gradient(90deg, rgba(16,185,129,0.15) 0%, rgba(16,185,129,0.05) 100%)'
                    : 'linear-gradient(90deg, rgba(245,158,11,0.15) 0%, rgba(245,158,11,0.05) 100%)',
                backdropFilter: 'blur(10px)',
            }}
        >
            {/* ChurchTools Logo */}
            <Stack
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    flexShrink: 0,
                    bgcolor: 'rgba(59,130,246,0.1)',
                    borderRadius: 1,
                    p: 0.5,
                }}
            >
                <img
                    src={ChurchToolsLogo}
                    alt=""
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Stack>
            {/* Service Info */}
            <Stack sx={{ flex: 1, minHeight: 48, minWidth: 0, justifyContent: 'center' }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '0.75rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                    }}
                >
                    {name}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.2,
                    }}
                >
                    {responsible}
                </Typography>
            </Stack>
            {/* Status Icon */}
            {agreed ? (
                <CheckCircleIcon
                    color="success"
                    sx={{
                        fontSize: 28,
                        flexShrink: 0,
                    }}
                />
            ) : (
                <HelpOutlineIcon
                    color="warning"
                    sx={{
                        fontSize: 28,
                        flexShrink: 0,
                    }}
                />
            )}
        </Stack>
    );
};

export default memo(CategoryItemChurchTools);
